/* ==========================================================================
   lp-sticky.js — mobilde sabit (sticky) randevu cubugu.
   ==========================================================================

   Sayfa uzun; ortada kaydiran ziyaretci CTA butonunu kaybediyordu (bkz.
   layout/theme.liquid'deki `.lp-sticky-cta` cubugu, sadece ana sayfada
   basiliyor). Bu betik SADECE bir seyi yapar: #randevu bolumu ekranda
   goruntulenirken cubugu gizler (Cal.com takvimi zaten ekrandayken ayrica
   bir CTA'ya gerek yok).

   Bu davranis KRITIK DEGIL. IntersectionObserver yoksa ya da #randevu
   bolumu sayfada bulunamazsa betik sessizce hicbir sey yapmaz; cubuk her
   zaman gorunur kalir, hicbir icerik gizlenmez.
   ========================================================================== */

(function () {
  'use strict';

  var bar = document.querySelector('.lp-sticky-cta');
  if (!bar) return;

  var randevu = document.getElementById('randevu');
  if (!randevu || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-hidden', entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );

  observer.observe(randevu);
})();
